var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Column, CreateDateColumn, Entity, Index, PrimaryGeneratedColumn, UpdateDateColumn } from 'typeorm';
import { getLongTextEntityType } from '@/common/config';
let SuiObject = class SuiObject {
    id;
    txDigest;
    beforeTx;
    objectId;
    objectVersion;
    type;
    data;
    changeType; // created, deleted, changed
    updatedAt;
    createdAt;
};
__decorate([
    PrimaryGeneratedColumn(),
    __metadata("design:type", Number)
], SuiObject.prototype, "id", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], SuiObject.prototype, "txDigest", void 0);
__decorate([
    Column(),
    __metadata("design:type", Boolean)
], SuiObject.prototype, "beforeTx", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], SuiObject.prototype, "objectId", void 0);
__decorate([
    Column('bigint'),
    __metadata("design:type", String)
], SuiObject.prototype, "objectVersion", void 0);
__decorate([
    Column(),
    Index(),
    __metadata("design:type", String)
], SuiObject.prototype, "type", void 0);
__decorate([
    Column(getLongTextEntityType()),
    __metadata("design:type", String)
], SuiObject.prototype, "data", void 0);
__decorate([
    Column(),
    __metadata("design:type", String)
], SuiObject.prototype, "changeType", void 0);
__decorate([
    UpdateDateColumn(),
    __metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], SuiObject.prototype, "updatedAt", void 0);
__decorate([
    CreateDateColumn(),
    __metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], SuiObject.prototype, "createdAt", void 0);
SuiObject = __decorate([
    Entity({ name: 'sui_object' })
], SuiObject);
export { SuiObject };
//# sourceMappingURL=module.js.map